import Reveal from "@/components/base/Reveal";
import { testSubjects, testPoints, testImage } from "@/mocks/admission";

export default function Test() {
  return (
    <section id="test" className="scroll-mt-24 bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-content px-5 md:px-8">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <Reveal>
            <div className="aspect-[4/3] w-full overflow-hidden rounded-2xl">
              <img
                src={testImage}
                alt="입학테스트 진단 안내 이미지"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </Reveal>

          <Reveal delay={100}>
            <span className="font-label text-xs tracking-[0.25em] text-primary-600">
              PLACEMENT TEST
            </span>
            <h2 className="mt-3 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              지금의 실력을 정확히 알아야,
              <br />
              올바른 계획이 시작됩니다
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-700">
              입학테스트는 합격과 불합격을 가르는 시험이 아닙니다. 학생의 현재
              실력과 취약점을 파악해 가장 적합한 반과 커리큘럼을 설계하기 위한
              진단입니다.
            </p>

            <div className="mt-8 grid gap-3 sm:grid-cols-3">
              {testSubjects.map((s) => (
                <div
                  key={s.name}
                  className="rounded-2xl border border-background-200 bg-background-50 p-5"
                >
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                    <i className={`${s.icon} text-lg`} />
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">
                    {s.name}
                  </h3>
                  <p className="mt-1 text-xs leading-relaxed text-foreground-700">{s.detail}</p>
                </div>
              ))}
            </div>

            <ul className="mt-8 space-y-2.5">
              {testPoints.map((point) => (
                <li
                  key={point}
                  className="flex items-center gap-2.5 text-sm text-foreground-800"
                >
                  <i className="ri-check-line text-primary-600" />
                  {point}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}